import { render, staticRenderFns } from "./questDialogDrops.vue?vue&type=template&id=245218bd&scoped=true&"
import script from "./questDialogDrops.vue?vue&type=script&lang=js&"
export * from "./questDialogDrops.vue?vue&type=script&lang=js&"
import style0 from "./questDialogDrops.vue?vue&type=style&index=0&id=245218bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245218bd",
  null
  
)

export default component.exports